import React from 'react';
import { BrowserRouter as Router, Route, Routes } from 'react-router-dom';
import './App.css';
import { GoogleOAuthProvider } from "@react-oauth/google";
import UserProvider from './context/UserProvider';
import { DesktopViewProvider } from './context/DesktopViewContext';
import Header from './components/Header';
import Home from './components/Home';
import Job from './components/Job';
import CreateJob from './components/CreateJob';
import JobApply from './components/JobApply';
import CV from './components/CV';
import Admin from './components/Admin';
import Why from './components/Why';
import DataPrivacy from './components/DataPrivacy';
import Users from './components/Users';
import UpdateCompany from './components/UpdateCompany';
function App() {
  const client_id = process.env.REACT_APP_CLIENT_ID;
  return (
    <UserProvider>
      <DesktopViewProvider>
    <GoogleOAuthProvider clientId={client_id}>
  <div className={'App'}>
      <Router>

      <Header />
      
      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/job/:jobId" element={<Job />} /> 
        <Route path="/apply/:jobId" element={<JobApply />} /> 
        <Route path="/createjob" element={<CreateJob />} />
        <Route path="/cv" element={<CV />} />
        <Route path="/admin" element={<Admin />} />
        <Route path="/tellmewhy" element={<Why />} />
        <Route path="/users" element={<Users />} />
        <Route path="/data-privacy" element={<DataPrivacy />} />
        <Route path="/company" element={<UpdateCompany />} />
      </Routes>
    </Router>
    </div>
    </GoogleOAuthProvider>
    </DesktopViewProvider>
    </UserProvider>
  );
}

export default App;
